import BackendService from './BackendService';

async function getSalesPersons() {
  return BackendService.getData('/sales-persons/');
}
async function createSalesPersons(data) {
  return BackendService.postData('/sales-persons/', data);
}
async function updateSalesPersons(id, data = {}) {
  return BackendService.put(`/sales-persons/${id}/`, data);
}
async function deleteSalesPersons(id) {
  return BackendService.destroy(`/sales-persons/${id}/`, '');
}
async function getSalespersonSummaryReport(data) {
  return BackendService.postData(`/reports/service-staff-summary/`, data);
}
async function getSalespersonItemWiseReport(id, data) {
  return BackendService.postData(`/reports/service-staff-summary/${id}/item-wise/`, data);
}
async function getSalespersonDetailedReport(id, data) {
  return BackendService.postData(`/reports/service-staff-summary/${id}/detailed-report/`, data);
}

const SalesPersonService = {
  getSalesPersons,
  createSalesPersons,
  updateSalesPersons,
  deleteSalesPersons,
  getSalespersonSummaryReport,
  getSalespersonItemWiseReport,
  getSalespersonDetailedReport,
};

export default SalesPersonService;
